import React from "react";
import MarketingContactless from "components/Marketing/Contactless";
import Layout from "components/Layout";
import { fetchTestLink } from "utils/shortLink";
import { PAGE_KEYS, preparePageResponse } from "utils/render";

const FeaturesContactless = (props) => {
  return <Layout>{() => <MarketingContactless {...props} />}</Layout>;
};

export const getServerSideProps = async () => {
  const data = await fetchTestLink({
    shortId: process.env.DEMO_SHORT_LINK_ID_A,
    apiKey: process.env.PRICE_BLOCS_PLATFORM_KEY
  });

  const pageInput = {
    data,
    keys: PAGE_KEYS.HOME
  };
  const response = preparePageResponse(pageInput);

  return {
    props: response
  };
};

export default FeaturesContactless;
